export const productionUrl = "https://www.hbm-machines.com";

/**
 * Delivery time ranges per country/region based on shipping zones
 */
export const DeliveryTimeRanges = {
	// Netherlands
	NL: { min: 1, max: 2 },
	BE: { min: 1, max: 2 },
	DE: { min: 1, max: 4 },
	FR: { min: 2, max: 4 },
	AT: { min: 2, max: 4 },
	ES: { min: 3, max: 6 },
	IT: { min: 3, max: 6 },

	// Rest of Europe (using existing countries from ExpectedDeliveryTime)
	BG: { min: 4, max: 8 },
	CH: { min: 4, max: 8 },
	CZ: { min: 4, max: 8 },
	DK: { min: 4, max: 8 },
	EE: { min: 4, max: 8 },
	FI: { min: 4, max: 8 },
	GR: { min: 4, max: 8 },
	HR: { min: 4, max: 8 },
	HU: { min: 4, max: 8 },
	IE: { min: 4, max: 8 },
	LT: { min: 4, max: 8 },
	LU: { min: 4, max: 8 },
	LV: { min: 4, max: 8 },
	MT: { min: 4, max: 8 },
	NO: { min: 4, max: 8 },
	PL: { min: 4, max: 8 },
	PT: { min: 4, max: 8 },
	RO: { min: 4, max: 8 },
	SE: { min: 4, max: 8 },
	SI: { min: 4, max: 8 },
	SK: { min: 4, max: 8 },
} as const;

/**
 * Helper function to get delivery time range for a country
 */
export function getDeliveryTimeRange(countryCode: string): {
	min: number;
	max: number;
} {
	return DeliveryTimeRanges[countryCode as keyof typeof DeliveryTimeRanges];
}
